import { render, staticRenderFns } from "./StartProduction.vue?vue&type=template&id=564a0224&scoped=true&"
import script from "./StartProduction.vue?vue&type=script&lang=js&"
export * from "./StartProduction.vue?vue&type=script&lang=js&"
import style0 from "./StartProduction.vue?vue&type=style&index=0&id=564a0224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a0224",
  null
  
)

export default component.exports